import { ArcDto } from './model.dto'
import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class EligibleArcDto {
  @Field(t => ArcDto, { nullable: true })
  arc?: ArcDto

  @Field(t => Boolean)
  isEligible!: boolean
}
